export const SCREEN_NAMES = {
  ADDRESS_INFORMATION: 'address information',
  ABOUT_SCAN_HEALTH: ' about scan health',
  DELETE_ACCOUNT: 'delete account',
  DELETE_CONFIRMATION: 'deletion confirmation',
  ENABLE_TEXT_NOTIFICATIONS: 'enable text notifications',
  COMPLETE_ONBOARDING: 'complete onboarding',
};
